import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import './Contact.less';
import { Row, Col } from 'antd';

type Props = {};

const Contact: React.FC<Props> = () => {
  const { t } = useTranslation('leadershipScreen');
  const dispatch = useDispatch();

  useEffect(() => {}, [dispatch]);

  return (
    <>
      <Row justify="center" align="top" style={{ marginTop: '40px' }}>
        <Col
          xs={24}
          sm={18}
          md={18}
          lg={18}
          xl={18}
          style={{ background: '#fff', padding: '20px' }}
        >
          <h1 className="title pt20">Contact</h1>
          <p className="text pt10">
            If you have any general questions about the University please contact us through our
            Facebook page{' '}
            <a href="https://www.facebook.com/TrickstarsUniversity">
              https://www.facebook.com/TrickstarsUniversity
            </a>
            .
          </p>
          <p className="text pt10">
            For technical support please check out our Facebook support page{' '}
            <a href="https://www.facebook.com/groups/639241180718230">
              https://www.facebook.com/groups/639241180718230
            </a>{' '}
            or email support@luckydogtraining.co.uk if you do not use Facebook.
          </p>

          <p className="text pt10">
            For any other enquiries please email Nicola@luckydogtraining.co.uk
          </p>
        </Col>
      </Row>
    </>
  );
};

export default Contact;
